import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import s from "./iconfont.es5471.js";
const i = {
  display: "block"
}, v = ({ size: e = 16, useVw: c, useRem: l, color: n, withColor: o, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const h = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(s, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-APIs", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-APIs"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? d(n, 0, "#262933") : "#262933",
        datafollowfill: o ? d(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M5.528 9.417c.58-3.032 3.017-5.28 5.907-5.28 2.391 0 4.58 1.62 5.51 3.938.224.56.708.952 1.263 1.091.316.08.622.196.914.346 1.61.829 2.803 2.697 2.803 4.963 0 1.175-.431 2.556-1.22 3.63-.782 1.065-1.855 1.758-3.14 1.758h-3.85a.8.8 0 1 0 0 1.6h3.85c1.927 0 3.434-1.055 4.43-2.41.988-1.347 1.53-3.059 1.53-4.578 0-2.818-1.486-5.261-3.671-6.385a5.878 5.878 0 0 0-1.256-.475.241.241 0 0 1-.168-.136c-1.144-2.849-3.872-4.942-6.995-4.942-3.777 0-6.777 2.917-7.479 6.579a.242.242 0 0 1-.131.16C1.86 10.301.475 12.541.475 15.093c0 3.465 2.548 6.368 5.88 6.368h2.376a.8.8 0 0 0 0-1.6H6.355c-2.313 0-4.28-2.046-4.28-4.768 0-1.99 1.084-3.665 2.491-4.401a1.84 1.84 0 0 0 .962-1.276Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.826 16.633a.61.61 0 1 1-1.157-.384l1.447-4.23a1.09 1.09 0 0 1 2.063.001l1.444 4.229a.61.61 0 1 1-1.156.383l-.288-.893H7.114l-.288.894Zm1.344-4.031.703 2.184H7.42l.704-2.184h.045Zm3.418 3.848a.605.605 0 1 0 1.209 0v-1.266h1.016c.44 0 .814-.082 1.123-.246.311-.163.549-.392.712-.685.164-.293.246-.63.246-1.014s-.08-.722-.243-1.015a1.691 1.691 0 0 0-.698-.69c-.305-.168-.675-.251-1.109-.251h-1.541a.715.715 0 0 0-.716.715v4.452Zm1.209-2.244h.82c.234 0 .425-.04.576-.122a.8.8 0 0 0 .341-.34c.076-.147.114-.316.114-.505 0-.192-.038-.36-.114-.502a.767.767 0 0 0-.34-.335 1.235 1.235 0 0 0-.582-.121h-.815v1.925Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M18.214 11.887a.605.605 0 1 0-1.21 0v4.563a.605.605 0 0 0 1.21 0v-4.563Z"
        }
      )
    )
  )));
}, I = v;
export {
  I as default
};
